export default __webpack_public_path__ + "static/media/logo.e156eee0.png";